import { render, staticRenderFns } from "./UserActivity.vue?vue&type=template&id=27a86d63&scoped=true&lang=pug"
import script from "./UserActivity.vue?vue&type=script&lang=js"
export * from "./UserActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a86d63",
  null
  
)

export default component.exports